export const retailEshopsFiltersName = {
  priceCoefficientChangedAtFilter: 'priceCoefficientChangedAtFilter',
}
export const retailWinesFiltersName = {
  additionalNameFilter: 'additionalNameFilter',
  withAdditionalNameFilter: 'withAdditionalNameFilter',
  priceChangeTypeFilter: 'priceChangeTypeFilter',
  priceChangedAtFilter: 'priceChangedAtFilter',
}
export const retailWinesFilterTitle = {
  additionalNameFilter: 'filters.names.additionalName',
  withAdditionalNameFilter: 'filters.names.withAdditionalName',
  priceChangeTypeFilter: 'filters.names.priceChangeType',
  priceChangedAtFilter: 'filters.names.priceChangedAt',
}
export const retaiPriceReportFilterTitle = {
  priceFilter: 'filters.names.priceFilter',
}
export const retailEshopsFiltersKey = {
  wineCountryFilter: 'wineCountry',
  producerFilter: 'tradeName',
  brandFilter: 'brand',
  nationalGITypeFilter: 'nationalGIType',
  geoIndicationFilter: 'geoIndication',
  specialClassificationFilter: 'specialClassification',
  wineTypeFilter: 'wineType',
  wineColourFilter: 'wineColor',
  sweetnessTypeFilter: 'sweetnessLevel',
  vintageFilter: 'vintage',
  grapesFilter: 'grapeAndMonocepage',
  bottleSizeFilter: 'bottleSize',
  packageTypeFilter: 'packageType',
  alcoholLevelFilter: 'chemicalAnalysisAlcohol',
  certificatesFilter: 'certification',
  wwlRatingFilter: 'wines.rating',
  rrpFilter: 'recommendedRetailPrice',
  retailPriceFilter: 'retailPrice',
  monocepageFilter: 'grapeAndMonocepage.monocepage',
  eShopCountryFilter: 'country',
  eShopFilter: 'name',
  wineRegionEUFilter: 'wineRegionEU',
  priceCoefficientChangedAtFilter: 'priceCoefficientChangedAt',
}
export const retailWinesFiltersKey = {
  eShopCountryFilter: 'merchant.country',
  eShopFilter: 'merchant.name',
  wineCountryFilter: 'product.wine.country',
  //countryFilter - фильтр для преобразования в retail/buyers-wine колонка LRP
  countryFilter: 'product.wine.country',
  producerFilter: 'product.wine.tradeName',
  brandFilter: 'product.wine.brand',
  nationalGITypeFilter: 'product.wine.nationalGIType',
  geoIndicationFilter: 'product.wine.geoIndication',
  specialClassificationFilter: 'product.wine.specialClassification',
  wineTypeFilter: 'product.wine.wineType',
  wineColourFilter: 'product.wine.wineColor',
  sweetnessTypeFilter: 'product.wine.sweetnessLevel',
  vintageFilter: 'product.wine.vintage',
  retailPriceFilter: 'pricePerBottle',
  rrpFilter: 'recommendedRetailPrice',
  wwlRatingFilter: 'product.wine.rating',
  grapesFilter: 'grapeAndMonocepage',
  alcoholLevelFilter: 'chemicalAnalysisAlcohol',
  certificatesFilter: 'product.wine.certification',
  bottleSizeFilter: 'product.bottleSize',
  packageTypeFilter: 'product.packageType',
  monocepageFilter: 'grapeAndMonocepage.monocepage',
  hasBottleImageFilter: 'product.hasBottleImage',
  hasFrontLabelImageFilter: 'product.hasFrontLabelImage',
  hasBackLabelImageFilter: 'product.hasBackLabelImage',
  hasVerifiedRepresentativeFilter: 'product.hasVerifiedRepresentative',
  additionalNameFilter: 'product.wine.keywords',
  withAdditionalNameFilter: 'product.wine.keywordsExists',
  eShopsBrandsFilter: 'isMerchantBrand',
  onlyLowestMerchantPriceFilter: 'onlyLowestMerchantPrice',
  grapeFilter: 'grape',
  priceChangeTypeFilter: 'priceChangeType',
  priceChangedAtFilter: 'priceChangedAt',
}
export const retailGIFiltersKey = {
  wineCountryFilter: 'wineCountry',
  producerFilter: 'tradeName',
  brandFilter: 'brand',
  nationalGITypeFilter: 'wineNationalGIType',
  geoIndicationFilter: 'wineGeoIndication',
  specialClassificationFilter: 'specialClassification',
  wineTypeFilter: 'wineType',
  wineColourFilter: 'wineColor',
  sweetnessTypeFilter: 'sweetnessLevel',
  vintageFilter: 'vintage',
  retailPriceFilter: 'retailPrice',
  rrpFilter: 'recommendedRetailPrice',
  wwlRatingFilter: 'rating',
  grapesFilter: 'grapeAndMonocepage',
  alcoholLevelFilter: 'chemicalAnalysisAlcohol',
  certificatesFilter: 'certification',
  bottleSizeFilter: 'bottleSize',
  packageTypeFilter: 'packageType',
  monocepageFilter: 'grapeAndMonocepage.monocepage',
}
